<template>
  <div class="owc-footer-contact-info">
    <div class="wb-grid-row">
      <div class="owc-footer-contact-info__container wb-grid-col-mq1-12">
        <div v-if="title" class="owc-footer-contact-info__text">
          {{ title }}
        </div>
        <div class="owc-footer-contact-info__contact-container">
          <wb-icon v-if="title" class="owc-footer-contact-info__icon" name="call" role="none"></wb-icon>
          <div ref="contact" v-html="text"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { ContactInfoData, ContactInfoMethods, ContactInfoComputed, ContactInfoProps } from './ContactInfo';
import { componentMode } from './Footer.config';

export default ComponentInitializeDispatcher.extend<
  ContactInfoData,
  ContactInfoMethods,
  ContactInfoComputed,
  ContactInfoProps
>({
  name: 'owc-contact-info',
  props: {
    contactInfo: {
      type: Object,
    },
  },
  computed: {
    isEdit: function(): boolean {
      return componentMode.isEditMode;
    },
    title: function(): string | undefined {
      return this.isEdit ? this.componentData?.title : this.contactInfo?.title;
    },
    text: function(): string {
      return this.isEdit ? this.componentData?.text : this.contactInfo?.text;
    },
  },
  mounted() {
    const selectContact = (this.$refs.contact as HTMLElement).querySelector('a');
    selectContact?.classList.add('owc-footer-contact-info__contact');
  },
});
</script>

<style lang="scss">
@import '@owc-styles/utils/rtl-utils';

$contactInfoModuleName: 'owc-footer-contact-info';

.#{$contactInfoModuleName} {
  @include wb-type-copy-secondary;
  width: 100%;

  color: var(--wb-white);

  &__container {
    display: flex;
    flex-direction: column;

    margin: var(--wb-spacing-s) 0;

    @include breakpoint-from(mq3) {
      flex-direction: row;
      align-items: center;
    }
  }
  &__text {
    @include breakpoint-from(mq3) {
      margin: 0;
    }

    margin-bottom: var(--wb-spacing-xxs);
  }
  &__contact-container {
    display: flex;
    align-items: center;

    @include breakpoint-from(mq3) {
      margin: 0;
    }
  }
  &__icon {
    width: 16px;
    height: 16px;

    margin-right: var(--wb-spacing-xxs);

    @include breakpoint-from(mq3) {
      margin: 0 var(--wb-spacing-xxs);
    }
  }
  &__contact {
    color: var(--wb-white);
    text-decoration: none;
  }
}

@include rtl-rule('.owc-footer-contact-info', false) {
  &__text {
    text-align: initial;
  }
}
</style>
